import * as httpx from "httpx"
import * as events from "./events"
import { CancellablePromise } from "real-cancellable-promise"
import {
	VideoSearchRequest,
	VideoSearchResponse,
	VideoFindResponse,
	VideoPatchRequest,
	VideoPatchResponse,
	VideoUploadResponse,
	VideoTrainRequest,
	VideoTrainResponse,
	VideoRescoreRequest,
	VideoRescoreResponse,
} from "brandguard/brandguard.video_pb"

export function upload(
	data: FormData,
	file: File,
	bid: string,
	...options: httpx.option[]
): CancellablePromise<VideoUploadResponse> {
	data.append("content", file)
	return httpx
		.upload<VideoUploadResponse>(`${httpx.urlstorage.host()}/brands/${bid}/bg/video/training`, data, ...options)
		.then((resp) => ({
			media: resp.media,
			event: events.zero(resp.event),
		}))
}

export function search(
	req: VideoSearchRequest,
	bid: string,
	...options: httpx.option[]
): CancellablePromise<VideoSearchResponse> {
	return httpx
		.get<VideoSearchResponse>(`${httpx.urlstorage.host()}/brands/${bid}/bg/video/training`, req, ...options)
		.then((resp) => ({
			...resp,
			items: (resp.items || []).map((item) => ({ media: item.media, event: events.zero(item.event) })),
		}))
}

export function find(id: string, bid: string, ...options: httpx.option[]): CancellablePromise<VideoFindResponse> {
	return httpx
		.get<VideoFindResponse>(`${httpx.urlstorage.host()}/brands/${bid}/bg/video/training/${id}`, {}, ...options)
		.then((resp) => ({
			media: resp.media,
			event: events.zero(resp.event),
		}))
}

export function patch(
	bid: string,
	id: string,
	req: VideoPatchRequest,
	...options: httpx.option[]
): Promise<VideoPatchResponse> {
	return httpx
		.patch<VideoPatchResponse>(`${httpx.urlstorage.host()}/brands/${bid}/bg/video/training/${id}`, req, ...options)
		.then((resp) => ({
			media: resp.media,
			event: events.zero(resp.event),
		}))
}

export function requeue(id: string, bid: string, ...options: httpx.option[]): Promise<VideoFindResponse> {
	return httpx
		.post<VideoFindResponse>(`${httpx.urlstorage.host()}/brands/${bid}/bg/video/training/${id}/requeue`, {}, ...options)
		.then((resp) => ({
			media: resp.media,
			event: events.zero(resp.event),
		}))
}

export function transfer(
	id: string,
	bid: string,
	req: VideoPatchRequest,
	...options: httpx.option[]
): CancellablePromise<VideoPatchResponse> {
	return httpx
		.post<VideoPatchResponse>(
			`${httpx.urlstorage.host()}/brands/${bid}/bg/video/training/${id}/transfer`,
			req,
			...options,
		)
		.then((resp) => ({
			media: resp.media,
			event: events.zero(resp.event),
		}))
}

export async function enqueue(
	bid: string,
	req: VideoTrainRequest,
	...options: httpx.option[]
): Promise<VideoTrainResponse> {
	return httpx.post<VideoTrainRequest>(
		`${httpx.urlstorage.host()}/brands/${bid}/bg/video/training/enqueue`,
		req,
		...options,
	)
}

export async function rescore(
	bid: string,
	req: VideoRescoreRequest,
	...options: httpx.option[]
): Promise<VideoRescoreResponse> {
	return httpx.post<VideoRescoreRequest>(
		`${httpx.urlstorage.host()}/brands/${bid}/bg/video/training/rescore`,
		req,
		...options,
	)
}

export function destroy(bid: string, id: string, ...options: httpx.option[]): Promise<VideoPatchResponse> {
	return httpx
		.destroy<VideoPatchResponse>(`${httpx.urlstorage.host()}/brands/${bid}/bg/video/training/${id}`, {}, ...options)
		.then((resp) => ({
			media: resp.media,
			event: events.zero(resp.event),
		}))
}
